/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_User_Not_FoundInputs */



/**
* | output |
* | --- |
* | "No account found with this email address." |
*
* @param {Login_Error_User_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_user_not_found = /** @type {((inputs?: Login_Error_User_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_User_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun compte trouvé avec cette adresse email.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurde kein Konto mit dieser E-Mail-Adresse gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun account trovato con questo indirizzo email.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Учетная запись с этим адресом электронной почты не найдена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontró ninguna cuenta con esta dirección de correo electrónico.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到与此电子邮件地址关联的帐户。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このメールアドレスに該当するアカウントは見つかりません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस ईमेल पते से कोई खाता नहीं मिला।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma conta encontrada com este endereço de e-mail.")
	return /** @type {LocalizedString} */ ("No account found with this email address.")
});